module.exports = __webpack_public_path__ + "img/CPCNewLogo.e574651b.png";